import React, {FunctionComponent} from 'react';
import {Table, TableBody, TableCell, TableHead, TableRow} from '@material-ui/core';
import {PriceTierRow} from './PriceTierRow';
import {PriceTierWithCatalogPresence} from '~/lib/sharedInterfaces';

const TableHeaders = ['Label', 'Method', 'Catalog Level', 'Associated Stores', 'Status'];
export interface TierListTableProps {
    onActiveChange?: (tier: PriceTierWithCatalogPresence, isActive: boolean) => void;
    onConvert?: (tier: PriceTierWithCatalogPresence) => void;
    onEditTier?: (tier: PriceTierWithCatalogPresence) => void;
    onReassign?: (tier: PriceTierWithCatalogPresence) => void;
    priceTiers: PriceTierWithCatalogPresence[];
    readOnly?: boolean;
}

export const PriceTierListTable: FunctionComponent<TierListTableProps> = (
    props: TierListTableProps
) => {
    const {onActiveChange, onConvert, onEditTier, onReassign, priceTiers, readOnly = false} = props;

    const onActivate = (tier: PriceTierWithCatalogPresence) => {
        onActiveChange!(tier, true);
    };

    const onDeactivate = (tier: PriceTierWithCatalogPresence) => {
        onActiveChange!(tier, false);
    };

    return (
        <div className="price-tier-list-table-container">
            <Table>
                <TableHead>
                    <TableRow>
                        {TableHeaders.map((header, idx) => (
                            <TableCell key={idx}>{header}</TableCell>
                        ))}
                        {readOnly ? null : <TableCell />}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {priceTiers.map((tier, idx) => (
                        <PriceTierRow
                            key={idx}
                            onActivate={onActivate}
                            onConvert={onConvert}
                            onDeactivate={onDeactivate}
                            onEditTier={onEditTier}
                            onReassign={onReassign}
                            priceTier={tier}
                            readOnly={readOnly}
                        />
                    ))}
                </TableBody>
            </Table>
        </div>
    );
};
